export default class ReturnBasketLine
{
    id                              = null;
    order_reference                 = null;
    rdate	                        = null;
    return_reason_code              = null;
    return_questionnaire_answers    = {};
    special_price                   = null;
    returned_by                     = null;
    ecom                            = null;
    icom                            = null;
    created_at                      = null;
    updated_at                      = null;

    //-------------------------------------------------------------------------- CONSTRUCTOR

    constructor(attributes = {})
    {
        if(attributes)
        {
            this.setAttributes(attributes);
        }
    }

    //-------------------------------------------------------------------------- ATTRIBUTES

    setAttributes(attributes)
    {
        for(const key in attributes)
        {
            if(this[key] !== undefined)
            {
                this[key] = attributes[key];
            }
        }
    }

    //-------------------------------------------------------------------------- SETTERS

    setReturnQuestionnaireAnswersAttribute(key, val)
    {
        this.return_questionnaire_answers[key] = val;
    }

    //-------------------------------------------------------------------------- GETTERS

    getReturnQuestionnaireAnswersAttribute(key)
    {
        return this.return_questionnaire_answers[key];
    }
}
